import { ThemeMode, useLayout } from "../../../context"
import { TUTELLUS_DESKTOP_LOGO_DARK, TUTELLUS_DESKTOP_LOGO_LIGHT } from "../../../js/const/logos"
import styles from "./index.module.css"

interface HeaderLogoProps {
  theme?: ThemeMode
}

export const HeaderLogo: React.FC<HeaderLogoProps> = ({ theme }) => {
  const { themeMode } = useLayout()

  const currentTheme = theme !== undefined ? theme : themeMode

  const logo = currentTheme === ThemeMode.LIGHT ? TUTELLUS_DESKTOP_LOGO_DARK : TUTELLUS_DESKTOP_LOGO_LIGHT

  return (
    <picture className={styles.logo}>
      <img src={logo} alt="Tutellus Logo" loading="eager" width="auto" height="auto" className={styles.logoImage} />
    </picture>
  )
}
